import { makeStyles } from 'e100-react-components';

export const useStyles = makeStyles(({ spacing }) => ({
  root: {
    marginBottom: spacing(0.5)
  }
}));